// 指标相关接口
import request from './request'
import { INDICATOR_TYPES } from '@/utils/constants'

/**
 * 获取指标详情
 * @param {string} type - 指标类型 (liver, stomach, kidney 等)
 * @param {Object} params - 请求参数
 * @param {string} params.userId - 用户 ID
 * @returns {Promise}
 */
export function getIndicatorByUserId(type, params) {
  if (!Object.values(INDICATOR_TYPES).includes(type)) {
    return Promise.reject(new Error(`Invalid indicator type: ${type}`))
  }

  return request({
    url: `/api/${type}/get-by-user-id`,
    method: 'get',
    params
  })
}

/**
 * 获取生理年龄详情
 * @param {Object} params - 请求参数
 * @param {string} params.userId - 用户 ID
 * @returns {Promise}
 */
export function getPhysiologicalAgeByUserId(params) {
  return request({
    url: '/api/physiological-age/get-by-user-id',
    method: 'get',
    params
  })
}

export function getPulseByUserId(params) {
  return request({
    url: '/api/pulse/get-by-user-id',
    method: 'get',
    params
  })
}
// 部位详情
export function bizIntroduce(id) {
	return request({
		url: '/api/biz-introduce/get-by-title?title=' +id ,
		method: 'get',
	})
}